{
    "CmeList_Column_ID": "ID",
    "CmeList_Column_Description": "Beschrijving",
    "CmeList_Column_ChildCMEs": "CME's",
    "CmeList_Column_TelSyss": "Telefoonservers",
    "CmeList_Column_Partitions": "Partities",
    "CmeList_Column_Users": "Gebruikers",
    "CmeList_CountLink_TelSyssAria": "Open telefonieservers gefilterd naar deze CM-omgeving",
    "CmeList_CountLink_PartitionsAria": "Openbare codes gefilterd voor deze CM-omgeving",
    "CmeList_CountLink_UsersAria": "Open applicatiegebruikers gefilterd naar deze CM-omgeving",
    "NAME": "CmeListLanguage"
}